import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import TabBar from '../components/ui/TabBar';
import { SchoolDataProvider } from './SchoolDataProvider';
import StatusBanner from './StatusBanner';
import TodayPage from './TodayPage';
import WeekPage from './WeekPage';
import FlaggedPage from './FlaggedPage';

// Router scoped to the school module only — mounted fresh each time
// StudentView becomes the active appState, so it never conflicts with Grove's
// own hand-rolled appState/hash navigation elsewhere in the app.
//
// There is no "My Board" tab any more: placing the week's tiles happens on
// This week (which is the board) and on Today (one tap to claim one now), so
// unplaced work is never hidden one tab away from the student. A bookmarked
// /school/board falls through the catch-all to Today.

const TABS = [
  { id: 'today',   label: 'Today',     path: '/school/today' },
  { id: 'week',    label: 'This week', path: '/school/week' },
  { id: 'flagged', label: 'Flagged',   path: '/school/flagged' },
];

function SchoolNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const active = TABS.find(t => location.pathname.startsWith(t.path))?.id || 'today';
  return (
    <TabBar
      tabs={TABS.map(({ id, label }) => ({ id, label }))}
      value={active}
      onChange={id => navigate(TABS.find(t => t.id === id).path)}
    />
  );
}

export default function SchoolRoutes() {
  return (
    // Provider outside the router: it's router-agnostic (the owner's tabs use
    // it without one) and never remounts if the router does.
    <SchoolDataProvider>
      <BrowserRouter>
        <SchoolNav />
        <StatusBanner />
        <Routes>
          <Route path="/school/today" element={<TodayPage />} />
          <Route path="/school/week" element={<WeekPage />} />
          <Route path="/school/flagged" element={<FlaggedPage />} />
          <Route path="*" element={<Navigate to="/school/today" replace />} />
        </Routes>
      </BrowserRouter>
    </SchoolDataProvider>
  );
}
